import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import { PATH_AUDIT_LOGS } from './paths';
import AuditLogsList from '../pages/AuditLogsList';

const AUDIT_LOG_ROUTES = [
  {
    path: PATH_AUDIT_LOGS.list,
    roles: ['audit_logs.view'],
    component: <AuditLogsList />,
    index: true,
  },
];

export const AuditLogsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {AUDIT_LOG_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>{route.component}</RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
